<template>
  <div>
    <el-form :model="post" :rules="rules" ref="annonceEdit">

        <ubi-page-container class="PostEdit" wide-main-content>

            <template v-slot:page-actions>
                <el-row>
                    <el-dropdown @command="handleCommand" style="margin-right: 15px;">
                        <el-button type="primary" v-loading="loading">
                            {{ $t("posts.edit.save") }}...<em class="el-icon-arrow-down el-icon--right"></em>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="saveModifications" v-if="post.id && post.etat !== 'B'">
                                {{ $t("posts.edit.saveModifications") }}
                            </el-dropdown-item>
                            <el-dropdown-item v-if="post.etat !== 'M' && currentType == null" command="diffuseNow">
                                {{ $t("posts.edit.diffuseNow") }}
                            </el-dropdown-item>
                            <el-dropdown-item command="saveDraft" v-if="currentType == null">
                                {{ $t("posts.edit.saveDraft") }}
                            </el-dropdown-item>
                            <el-dropdown-item command="saveModel"  v-if="post.etat !== 'M' && currentType == null && (post.nbDiffusions == 0)">
                                {{ $t("posts.edit.createModel") }}
                            </el-dropdown-item>
                            <el-dropdown-item command="saveModel"  v-if="post.etat !== 'M' && currentType == 'terrain'">
                                {{ $t("posts.edit.createAsLand") }}
                            </el-dropdown-item>
                            <el-dropdown-item command="saveModel"  v-if="post.etat !== 'M' && currentType == 'modele' && (post.nbDiffusions == 0)">
                                {{ $t("posts.edit.createModel") }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                    <el-button v-loading="loading" type="success" @click="modalDeleteModel = true"
                               v-if="post.etat === 'M' && !isSubUser">
                        <span @click="eventAnalytics('supprimer_modele')" v-if="currentType == 'terrain'">{{ $t("posts.edit.deleteLand") }}</span>
                        <span @click="eventAnalytics('supprimer_modele')" v-else>{{ $t("posts.edit.deleteModel") }}</span>
                    </el-button>

                    <el-button @click="$router.go(-1)">{{ $t("posts.edit.cancel") }}</el-button>
                </el-row>
            </template>

            <template v-slot:page-tabs>
                <el-tabs v-model="currentTab" @tab-click="beforeLeavingTab" class="PostEdit-tabs">
                    <el-tab-pane
                        v-for="tab in tabs"
                        :key="tab.name"
                        :label="tab.title"
                        :name="tab.name"
                        :disabled="tab.disabled"
                    />
                </el-tabs>
            </template>

            <div class="PostEdit-content">
                <PostEditImmo v-if="this.universe === 'IMMO' && this.labelsLoaded && this.currentType== null && this.postLoaded" v-on:change-city-rule="changeCityRule" v-on:check-rules-surface="changeRulesSurface" :post="post" :create="create" :currentTab="currentTab" :redirect="redirect" :id-user="idUser" @change-redirect="changeRedirect"></PostEditImmo>

                <PostEditVo v-else-if="this.universe === 'VO' && this.labelsLoaded" :post="post" :create="create"
                            v-on:change-object-type-auto="changeObjectTypeAuto"
                            :currentTab="currentTab"
                            :id-user="idUser"
                            v-on:change_financement_type="changeFinancementType($event)"></PostEditVo>

                <CreateModelCmi v-if="this.universe === 'IMMO' && this.labelsLoaded && this.postLoaded && (this.currentType==='terrain' || this.currentType==='modele' || (this.isCmiste && post.etat === 'M'))" :post="post" :currentTab="currentTab"></CreateModelCmi>

                <template v-if="browserContext.up('md')">
                    <hr/>
                    <div class="text-right">
                        <el-row>
                            <el-dropdown @command="handleCommand" style="margin-right: 15px;">
                                <el-button type="primary" v-loading="loading">
                                    {{ $t("posts.edit.save") }}...<em class="el-icon-arrow-down el-icon--right"></em>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="saveModifications" v-if="post.id">
                                        {{ $t("posts.edit.saveModifications") }}
                                    </el-dropdown-item>
                                    <el-dropdown-item v-if="post.etat !== 'M' && currentType == null" command="diffuseNow">
                                        {{ $t("posts.edit.diffuseNow") }}
                                    </el-dropdown-item>
                                    <el-dropdown-item command="saveDraft" v-if="currentType == null">
                                        {{ $t("posts.edit.saveDraft") }}
                                    </el-dropdown-item>
                                    <el-dropdown-item command="saveModel"  v-if="post.etat !== 'M' && currentType == null && (post.nbDiffusions == 0)">
                                        {{ $t("posts.edit.createModel") }}
                                    </el-dropdown-item>
                                    <el-dropdown-item command="saveModel"  v-if="post.etat !== 'M' && currentType === 'terrain'">
                                        {{ $t("posts.edit.createAsLand") }}
                                    </el-dropdown-item>
                                    <el-dropdown-item command="saveModel"  v-if="post.etat !== 'M' && currentType === 'modele' && (post.nbDiffusions == 0)">
                                        {{ $t("posts.edit.createModel") }}
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>

                            <el-button v-loading="loading" type="success" @click="modalDeleteModel = true"
                                       v-if="post.etat === 'M' && !isSubUser">
                                <span @click="eventAnalytics('supprimer_modele')" v-if="currentType === 'terrain'">{{ $t("posts.edit.deleteLand") }}</span>
                                <span @click="eventAnalytics('supprimer_modele')" v-else>{{ $t("posts.edit.deleteModel") }}</span>
                            </el-button>

                            <el-button @click="$router.go(-1)">{{ $t("posts.edit.cancel") }}</el-button>
                        </el-row>
                    </div>
                </template>
            </div>

            <el-dialog
                    :title="$t('posts.dialog.modelDeleteTitle')"
                    :visible.sync="modalDeleteModel"
                    width="30%">
                <span>{{ $t("posts.dialog.modelDeleteText") }}</span>
                <span slot="footer" class="dialog-footer">
                <el-button @click="modalDeleteModel = false">{{ $t("posts.dialog.cancel") }}</el-button>
                <el-button type="primary" @click="deletePostModel(post.id)">{{ $t("posts.dialog.confirm") }}</el-button>
              </span>
            </el-dialog>

            <dialog-draft-portal-selection
                :visible.sync="showDraftPortalDialog"
                :post-count="1"
                @keep="onDraftPortalKeep"
                @clear="onDraftPortalClear"
                @cancel="onDraftPortalCancel"
            />

        </ubi-page-container>
    </el-form>

    <ButtonScrollToTop @goToTop="goToTop" @scroll="handleScroll" v-if="buttonIsVisible"/>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'

import { deleteModel, getPostById, addRuleSurface, savePost, validateVin } from '@/services/posts'
import { clearPortalSelectionBeforeDraft } from '@/helpers/posts/draftPortalSelection'
import DialogDraftPortalSelection from '@/pages/posts/List/Dialog/DialogDraftPortalSelection'
import _findIndex from 'lodash/findIndex'

import { Tabs, TabPane } from 'element-ui'
import PostEditImmo from './PostEditImmo'
import PostEditVo from './PostEditVo'
import CreateModelCmi from './CreateModelCmi'
import ButtonScrollToTop from '@/components/ui/ButtonScrollToTop'
import { buttonScrollToTopMixin } from '@/mixins/buttonScrollToTopMixin'
import { getUsers } from '@/services/users'
import { getCreationProgrammeFromRoute, getAnnonceParenteFromRoute, getRedirectAfterSaveUrl } from '@/helpers/programContext'
import { getFromSnake } from '@/helpers/functions/getFromSnake'
import i18next from 'i18next'
import UbiPageContainer from '@/components/PageContainer.vue'

const REFERENCE_MAX_LENGTH = 20

export default {
  name: 'PostEdit',
  mixins: [buttonScrollToTopMixin],
  components: {
    UbiPageContainer,
    ButtonScrollToTop,
    PostEditVo,
    PostEditImmo,
    CreateModelCmi,
    DialogDraftPortalSelection,
    ElTabs: Tabs,
    ElTabPane: TabPane
  },
  inject: ['browserContext'],
  watch: {
    typeOffre: function (val) {
      const typeOffreTabIndex = _findIndex(this.tabs, function (o) {
        return o.name === 'detail'
      })
      if (!typeOffreTabIndex || !this.tabs[typeOffreTabIndex]) { return }
      if (val === 'L') {
        this.rules.prix[0].required = false
        this.rules.loyer_mensuel[0].required = true
      } else {
        this.rules.prix[0].required = true
        this.rules.loyer_mensuel[0].required = false
      }
      this.tabs[typeOffreTabIndex].disabled = !val
      this.$forceUpdate()
    },
    typeObjet: function (val) {
      const typeObjetTabIndex = _findIndex(this.tabs, function (o) {
        return o.name === 'description'
      })

      if (!typeObjetTabIndex || !this.tabs[typeObjetTabIndex]) { return }

      this.tabs[typeObjetTabIndex].disabled = !val
      // Si le client est CMISTE et qu'il choisit un terrain, on doit mettre le type d'offre à "V"
      if (this.isCmiste == true) {
        const typeOffreTabIndex = _findIndex(this.tabs, function (o) {
          return o.name === 'detail'
        })
        if (this.post.typeObjet == 1310) {
          this.post.typeOffre = 'V'
        } else {
          this.post.typeOffre = 'H'
        }
        if (val) {
          this.tabs[typeOffreTabIndex].disabled = !val
        }
      }
      this.$forceUpdate()
    }
  },
  data () {
    // Validations basiques côté frontend pour l'UX - la logique métier complète est côté backend
    const checkReference = (rule, value, callback) => {
      // Validation basique format - la logique métier est côté backend
      if (value && !/^[a-zA-Z0-9_\-\s.]+$/.test(value)) {
        return callback(new Error(this.$t('validator.referenceMustBeWithoutAccentAndSpecialCharacter')))
      }
      // Message informatif sous le champ (création uniquement, tous métiers).
      // N'empêche pas l'enregistrement : onSubmit demande confirmation.
      // En édition, on n'affiche rien pour les références déjà trop longues.
      if (this.create && value && String(value).length > REFERENCE_MAX_LENGTH) {
        return callback(new Error(this.$t('validator.errorReferenceExceed')))
      }
      return callback()
    }

    const checkNumeroImmatriculation = (rule, value, callback) => {
      // Validation de format basique pour l'UX - validation métier complète côté backend
      if (!value) return callback() // Pas obligatoire en validation frontend

      // Formats de base français (SIV et FNI)
      const regexSIV = /^(?:[A-HJ-NP-TV-Z]{2}|WW|W)-?\d{3}-?[A-HJ-NP-TV-Z]{2}$/i
      const regexFNI = /^[1-9]\d{0,3}(?:\s|\.|-)?[A-HJ-NP-TV-Z]{1,3}(?:\s|\.|-)?(?:[013-8]\d|2[0-9AB]|9[0-689ABCD]|97\d)$/i
      const regexCyclo = /^[A-HJ-NP-TV-Z]{1,2}(?:\s|\.|-)?\d{3}(?:\s|\.|-)?[A-HJ-NP-TV-Z]$/i

      const valueUpper = value.toUpperCase()

      // Vérification basique des lettres interdites I et O
      if (valueUpper.includes('I') || valueUpper.includes('O')) {
        return callback(new Error(this.$t('validator.plate.letterIandOnotAllowed')))
      }

      // Vérification format de base
      if (!(regexSIV.test(valueUpper) || regexFNI.test(valueUpper) || regexCyclo.test(valueUpper))) {
        return callback(new Error(this.$t('validator.plate.invalidFormat')))
      }

      return callback()
    }

    const checkNumeroVin = (rule, value, callback) => {
      if (!value) return callback()
      const vin = String(value).trim()
      if (!vin) return callback()
      if (vin.length !== 17) {
        return callback(new Error(this.$t('validator.serialNumberAtLeast', { number: 17 })))
      }
      validateVin(vin).then((result) => {
        if (result && result.success === true) {
          return callback()
        }
        const apiMessage = result && result.message
        return callback(new Error(apiMessage || this.$t('validator.vin.invalid')))
      }).catch(() => {
        return callback(new Error(this.$t('validator.vin.checkFailed')))
      })
    }

    const checkCylindree = (rule, value, callback) => {
      // Validation basique côté frontend pour l'UX - validation métier complète côté backend
      if (!value) return callback() // Pas obligatoire en validation frontend

      // Vérification basique : doit être un nombre positif
      if (isNaN(value) || value <= 0) {
        return callback(new Error(this.$t('validator.cylindreeMustBePositiveNumber')))
      }

      return callback()
    }

    return {
      create: false,
      loading: false,
      redirectToList: false,
      labelsLoaded: false,
      currentTab: 'main',
      currentType: null,
      modalDeleteModel: false,
      showDraftPortalDialog: false,
      redirect: false,
      mandatoryCity: true,
      users: [],
      idUser: null,
      post: { communiquer_adresse_exacte: 'oui' },
      postLoaded: false,
      rules: {
        typeOffre: [{ required: true, message: this.$t('validator.offerTypeRequired'), trigger: 'blur' }],
        typeObjet: [{ required: true, message: this.$t('validator.propertyTypeRequired'), trigger: 'blur' }],
        reference: [{ required: false, validator: checkReference, trigger: 'blur' }],
        titre: [{ required: true, message: this.$t('validator.titleRequired'), trigger: 'blur' }],
        surface_habitable: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        prix: [
          { required: true, message: this.$t('validator.priceRequired'), trigger: 'blur' },
          { type: 'number', message: this.$t('validator.priceMustBeNumber') }
        ],
        prix_min: [
          { required: false, message: this.$t('validator.priceRequired'), trigger: 'blur' },
          { type: 'number', message: this.$t('validator.priceMustBeNumber') }
        ],
        prix_max: [
          { required: false, message: this.$t('validator.priceRequired'), trigger: 'blur' },
          { type: 'number', message: this.$t('validator.priceMustBeNumber') }
        ],
        loyer_mensuel: [
          { required: false, message: this.$t('validator.monthlyRentRequired'), trigger: 'blur' },
          { type: 'number', message: this.$t('validator.monthlyRentMustBeNumber') }
        ],
        afficher_prix: [{ required: true, message: this.$t('validator.showPriceRequired'), trigger: 'blur' }],
        texte: [
          { required: true, message: this.$t('validator.textRequired'), trigger: 'blur' },
          { min: 10, message: this.$t('validator.textAtLeast', { number: 10 }), trigger: 'blur' }
        ],
        localText: [
          { required: true, message: this.$t('validator.textRequired'), trigger: 'blur' },
          { min: 10, message: this.$t('validator.textAtLeast', { number: 10 }), trigger: 'blur' }
        ],
        honoraires_negociation: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        communiquer_adresse_exacte: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        code_postal: [{ required: true, message: this.$t('validator.postalCodeRequired'), trigger: 'blur' }],
        ville_reelle: [{ required: true, message: this.$t('validator.realCityRequired'), trigger: 'blur' }],
        code_postal_reel: [{ required: true, message: this.$t('validator.realPostalCodeRequired'), trigger: 'blur' }],
        ville_contact_a_afficher: [{ required: true, message: this.$t('validator.cityToShowRequired'), trigger: 'blur' }],
        champ_Nombre: [{ type: 'number', message: this.$t('validator.mustBeNumber') }],
        numero_immatriculation: [{ validator: checkNumeroImmatriculation, trigger: 'blur' }],
        numero_serie: [{ validator: checkNumeroVin, trigger: 'blur' }],
        marque: [{ required: true, message: this.$t('validator.brandRequired'), trigger: 'blur' }],
        nb_pieces_logement: [{ required: false, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        financement_mensualites: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        modele: [{ required: true, message: this.$t('validator.modelRequired'), trigger: 'blur' }],
        modele_autre: [{ required: false, message: this.$t('validator.modelRequired'), trigger: 'blur' }],
        millesime: [{ required: true, message: this.$t('validator.yearRequired'), trigger: 'blur' }],
        version: [{ required: true, message: this.$t('validator.versionRequired'), trigger: 'blur' }],
        kilometrage: [{ required: true, message: this.$t('validator.mileageRequired'), trigger: 'blur' }],
        energie: [{ required: true, message: this.$t('validator.energyRequired'), trigger: 'blur' }],
        offre_titre: [{ max: 70, message: this.$t('validator.offerTitleMax', { number: 70 }), trigger: 'blur' }],
        cylindree: [{ validator: checkCylindree, trigger: 'blur' }]
      }
    }
  },
  methods: {
    ...mapMutations('posts', [
      'setPost'
    ]),
    ...mapMutations('postEditImmo', [
      'setAdManagerChanged',
      'SET_MEDIA_UPLOAD_DISABLED'
    ]),
    eventAnalytics (category) {
      this.$ga.event('annonce', 'clic', category, this.sitimmoUser.id)
    },
    isReferenceLengthWarningOnly (invalidFields) {
      if (!this.create || !this.post || this.post.reference == null || !invalidFields) {
        return false
      }
      const value = String(this.post.reference)
      if (value.length <= REFERENCE_MAX_LENGTH || !/^[a-zA-Z0-9_\-\s.]+$/.test(value)) {
        return false
      }
      const fields = Object.keys(invalidFields)
      return fields.length === 1 && fields[0] === 'reference'
    },
    confirmLongReference () {
      const text = (key) => String(this.$t(key))
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
      const message = '' +
        '<span class="reference-length-confirm__text">' + text('validator.errorReferenceExceed') + '</span>' +
        '<span class="reference-length-confirm__question">' + text('validator.confirmReferenceExceedQuestion') + '</span>' +
        '<span class="reference-length-confirm__note">' + text('validator.confirmReferenceExceedNote') + '</span>'
      return this.$confirm(message, this.$t('validator.confirmReferenceExceedTitle'), {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        customClass: 'reference-length-confirm',
        dangerouslyUseHTMLString: true
      }).then(() => true).catch(() => false)
    },
    async assignUser () {
      // Filtrer les utilisateurs selon le type d'utilisateur (aligner avec PostFormContactInfo)
      const filtresUsers = { active: true, pagination: false }
      if (this.isSubUser) {
        filtresUsers.id = this.user.id
      }
      this.users = await getUsers(filtresUsers)
      const list = this.users.list || []
      let userSelected = null

      // Pour les subUsers, utiliser l'utilisateur courant.
      // En édition, ne pas écraser le contact déjà défini sur l'annonce.
      if (this.isSubUser) {
        userSelected = list.find(user => user.id === this.user.id)
        if (userSelected && (this.create || !this.post.contact_a_afficher)) {
          this.post.contact_a_afficher = userSelected.fullname
        }
      } else {
        // Pour les autres utilisateurs, chercher le contact défini
        if (this.post.contact_a_afficher) {
          userSelected = list.find(user => user.fullname.trim() === this.post.contact_a_afficher.trim())
        }
        if (!userSelected && this.post.id_contact_a_afficher) {
          userSelected = list.find(user => user.id === this.post.id_contact_a_afficher)
        }
        // Contact supprimé : plus de correspondance nom/id — dernier contact actif ou utilisateur courant
        if (!userSelected && list.length === 1) {
          userSelected = list[0]
        }
        if (!userSelected && list.length > 1) {
          userSelected = list.find(user => user.id === this.user.id)
        }
        if (userSelected && !this.post.contact_a_afficher) {
          this.post.contact_a_afficher = userSelected.fullname
        }
      }

      if (userSelected) {
        const idOnPost = this.post.id_contact_a_afficher
        const idStillValid = idOnPost != null && idOnPost !== '' &&
          list.some(u => u.id === idOnPost)
        const resolvedContactId = idStillValid ? idOnPost : userSelected.id
        this.post.id_contact_a_afficher = resolvedContactId
        this.idUser = resolvedContactId
        this.$store.commit('postEditImmo/setIdContactManagePost', resolvedContactId)

        // En création subUser: pré-remplissage forcé.
        // En édition: ne pas écraser les coordonnées de l'annonce, sauf si l'id contact
        // référence un utilisateur supprimé (réalignement obligatoire pour la sauvegarde).
        const forceUpdate = this.create && this.isSubUser
        const orphanExplicitId = idOnPost != null && idOnPost !== '' && !idStillValid
        const rebindStaleContact = !this.create && orphanExplicitId

        if (orphanExplicitId && userSelected.fullname) {
          this.post.contact_a_afficher = userSelected.fullname
        }

        if (rebindStaleContact) {
          // Réalignement complet sur le contact actif (id supprimé / invalide), y compris si l'API
          // ne renvoie pas d'e-mail pour le contact (on vide l'ancienne valeur).
          this.post.email_a_afficher = userSelected.email || ''
          this.post.telephone_a_afficher = userSelected.phone || ''
          this.post.telephone_mobile_a_afficher = userSelected.mobile || ''
          this.post.adresse_contact_a_afficher = userSelected.address || ''
          this.post.code_postal_contact_a_afficher = userSelected.zipcode || ''
          this.post.ville_contact_a_afficher = userSelected.city || ''
        } else {
          if ((forceUpdate || !this.post.email_a_afficher) && userSelected.email) {
            this.post.email_a_afficher = userSelected.email
          }
          if ((forceUpdate || !this.post.telephone_a_afficher) && userSelected.phone) {
            this.post.telephone_a_afficher = userSelected.phone
          }
          if ((forceUpdate || !this.post.telephone_mobile_a_afficher) && userSelected.mobile) {
            this.post.telephone_mobile_a_afficher = userSelected.mobile
          }
          if ((forceUpdate || !this.post.adresse_contact_a_afficher) && userSelected.address) {
            this.post.adresse_contact_a_afficher = userSelected.address
          }
          if ((forceUpdate || !this.post.code_postal_contact_a_afficher) && userSelected.zipcode) {
            this.post.code_postal_contact_a_afficher = userSelected.zipcode
          }
          if ((forceUpdate || !this.post.ville_contact_a_afficher) && userSelected.city) {
            this.post.ville_contact_a_afficher = userSelected.city
          }
        }
      }
    },
    changeCityRule (payload) {
      this.rules.ville_reelle[0].required = payload.mandatoryCity
    },
    changeObjectTypeAuto (payload) {
      if (payload >= 16000) {
        this.rules.kilometrage[0].required = false
        this.rules.version[0].required = false
        this.rules.energie[0].required = false
        this.rules.cylindree[0].required = false
      } else {
        this.rules.kilometrage[0].required = true
        this.rules.version[0].required = true
        this.rules.energie[0].required = true
        this.rules.cylindree[0].required = true
      }
      if ((payload >= 13400) && (payload <= 13590)) {
        this.rules.modele_autre[0].required = true
      } else {
        this.rules.modele_autre[0].required = false
      }
    },
    async checkImmat (value) {
      const check = await this.$store.dispatch('postEditVo/checkCurrentImmatriculation', value)
      return check
    },
    changeRulesSurface (payload) {
      if (this.post.typeObjet >= 1300 && this.post.typeObjet < 1500) {
        delete (this.rules.nb_pieces_logement)
      }
      delete (this.rules.surface_habitable)
      delete (this.rules.surface_commerciale)
      delete (this.rules.surface_bureaux)
      delete (this.rules.surface_activite)
      delete (this.rules.surface_terrain)
      delete (this.rules.surface_stationnement)
      delete (this.rules.surface_min)

      this.rules = addRuleSurface(payload, this.rules)
    },
    changeRedirect (value) {
      this.redirect = value
    },
    async onSubmit (etat) {
      // Vider dans le store postManager le currentPost
      this.$store.commit('postManager/setCurrentPost', null)
      // Validation du formulaire côté client
      this.$refs.annonceEdit.validate(async (valid, invalidFields) => {
        const referenceLengthWarningOnly = this.isReferenceLengthWarningOnly(invalidFields)
        if (!valid && !referenceLengthWarningOnly) {
          this.redirectToList = false
          alert(this.$t('validator.alertMandatoryFields'))
          return false
        }
        if (referenceLengthWarningOnly) {
          const confirmed = await this.confirmLongReference()
          if (!confirmed) {
            this.redirectToList = false
            return false
          }
        }
        this.loading = true

        try {
          const postToSave = { ...this.post }
          // onSubmit() sans argument = « Enregistrer les modifications » (on garde le statut)
          const action = etat ? this.getActionFromEtat(etat) : 'saveModifications'
          if (!etat) {
            etat = postToSave.etat
          }
          // Gestion annonce parente si nécessaire (contexte lot / route posts-lots)
          const annonceParenteFromUrl = getAnnonceParenteFromRoute(this.$route)
          if (annonceParenteFromUrl) {
            const annonceParente = await getPostById(annonceParenteFromUrl)
            if (annonceParente.type !== 'error') {
              postToSave.annonce_parente_reference = getFromSnake(annonceParente, 'reference')
              postToSave.annonceParente = getFromSnake(annonceParente, 'id')
              postToSave.annonce_parente_type_objet = getFromSnake(annonceParente, 'type_objet')
            }
          }
          const lang = i18next.language
          const result = await savePost(
            postToSave,
            action,
            this.universe,
            this.sitimmoLogin,
            lang
          )

          if (result.type === 'error') {
            this.$message({ message: result.message, type: 'error', duration: 5000 })
            this.loading = false
            return false
          }

          // Fusionner result.ad sans écraser les flags déjà saisis (UBI-137)
          if (result.ad) {
            Object.keys(result.ad).forEach(key => {
              if (key === 'donnees' || key === 'equipements' || key === 'equipments') {
                return
              }
              if (this.post[key] === 'oui' || this.post[key] === 'non') {
                return
              }
              this.$set(this.post, key, result.ad[key])
            })
            this.formatPostBooleanValues(this.post)
          }
          this.post.etat = etat
          this.create = false

          // Gestion des comptes multiples
          if (this.hasMultiAccounts && !this.isSubUser) {
            this.setAdManagerChanged(true)
          }

          this.loading = false
          this.handleUpdateMessage({ message: result.message, type: 'success' })

          // Marquer que les modifications ont été sauvegardées (pour éviter la confirmation de sortie)
          this.redirect = true

          // La commande du menu décide : saveModifications reste sur la fiche
          if (this.redirectToList) {
            await this.handleRedirectAfterSave(etat)
          } else {
            this.goToNextTab()
          }
        } catch (error) {
          this.loading = false
          const errorMessage = (error.response && error.response.data && error.response.data.message) || this.$t('error.found')
          this.$message({ message: errorMessage, type: 'error', duration: 5000 })
          return false
        }

        if (this.hasMultiAccounts && !this.isSubUser) {
          this.setAdManagerChanged(false)
        }
      })
    },

    /**
     * Détermine l'action à partir de l'état demandé
     */
    getActionFromEtat (etat) {
      let action = 'saveModifications'
      switch (etat) {
        case 'B': action = 'saveDraft'
          break
        case 'M': action = 'saveModel'
          break
        case 'A': action = 'diffuseNow'
          break
      }
      return action
    },

    /**
     * Passe à l'onglet suivant si pas de redirection
     */
    goToNextTab () {
      const currentTabIndex = _findIndex(this.tabs, function (o) {
        return o.name === this.currentTab
      }.bind(this))
      if ((currentTabIndex + 1) < this.tabs.length) {
        this.currentTab = this.tabs[currentTabIndex + 1].name
      }
      window.scrollTo(0, 0)
    },

    /**
     * Gère la redirection après sauvegarde
     */
    async handleRedirectAfterSave (etat) {
      //  Pour les CMI, vérifier d'où on vient avant de rediriger
      if (this.isCmiste && (this.currentType != null || etat === 'M')) {
        // Si on vient de la bibliothèque (content-library), on y retourne
        // Sinon, on retourne sur la liste des annonces (posts-list)
        const fromContentLibrary = this.$route.query.from === 'content-library' ||
                                   this.$route.name === 'content-library' ||
                                   this.$route.matched.some(record => record.name === 'content-library')

        if (fromContentLibrary) {
          await this.$router.push({ name: 'content-library' })
        } else {
          // Rester sur la liste des annonces
          const redirectUrl = getRedirectAfterSaveUrl(this.$route)
          await this.$router.push(redirectUrl)
        }
      } else {
        if (etat === 'M') {
          this.$store.commit('postsListImmo/SET_FETCH_MODELES', true)
        }

        // Utiliser le contexte de l'URL pour déterminer la redirection
        const redirectUrl = getRedirectAfterSaveUrl(this.$route)
        await this.$router.push(redirectUrl)
      }
    },
    handleUpdateMessage (result) {
      if (result) {
        this.$message(result)
        // this.$router.go(-1)
      } else {
        this.$message({ message: this.$t('error.found'), type: 'error' })
      }
    },
    changeFinancementType (payload) {
      if (payload !== 'null') {
        this.post.financement_type = payload
      }
      switch (payload) {
        case 'null':
          this.rules.financement_mensualites[0].required = false
          this.rules.prix[0].required = true
          break
        case 'LOA':
          this.rules.financement_mensualites[0].required = true
          this.rules.prix[0].required = false
          break
        case 'LLD':
          this.rules.financement_mensualites[0].required = true
          this.rules.prix[0].required = false
          break
      }
    },
    formatPostBooleanValues (post) {
      const newPost = {}
      for (const property in post) {
        if (post[property] === true) {
          newPost[property] = 'oui'
        } else if (post[property] === false) {
          newPost[property] = 'non'
        } else {
          newPost[property] = post[property]
        }
      }
      this.post = newPost
    },
    async deletePostModel (id) {
      const call = deleteModel(id)
      if (call.type == 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }
      this.modalDeleteModel = false
      this.redirectToList = true
      await this.$router.push({ name: 'posts' })
    },
    beforeLeavingTab (activeName, oldActiveName) {
      window.scrollTo(0, 0)
    },
    handleCommand (command) {
      this.redirectToList = true

      switch (command) {
        case 'saveModifications':
          this.eventAnalytics('modifier')
          this.redirectToList = false
          this.onSubmit() // Le backend déterminera automatiquement le bon statut
          break
        case 'saveDraft':
          this.eventAnalytics('creation_brouillon')
          this.saveDraftWithPortalChoice()
          break
        case 'saveModel':
          this.eventAnalytics('creation_modele')
          this.onSubmit('M')
          break
        case 'diffuseNow':
          this.eventAnalytics('enregistrer_diffuser')
          this.onSubmit('A')
          break
      }
    },
    saveDraftWithPortalChoice () {
      if (this.post.etat === 'A') {
        this.showDraftPortalDialog = true
        return
      }
      this.onSubmit('B')
    },
    onDraftPortalKeep () {
      this.onSubmit('B')
    },
    async onDraftPortalClear () {
      const clearResult = await clearPortalSelectionBeforeDraft({
        id: this.post.id,
        selectedIds: [this.post.id],
        postsList: [this.post],
        sitimmoUser: this.sitimmoUser
      })

      if (clearResult && clearResult.type === 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        return
      }

      this.post.nbDiffusions = 0
      this.onSubmit('B')
    },
    onDraftPortalCancel () {
      // fermeture gérée par le composant dialog
    }
  },
  computed: {
    ...mapState('posts', ['filter', 'tabs']),
    ...mapState('postEditVo', ['existingImmatriculation']),
    ...mapState('postEditImmo', ['adManagerChanged', 'mediaUploadDisabled']),
    ...mapGetters(['isSubUser', 'hasMultiAccounts']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    universe () {
      return this.sitimmoUser.univers
    },
    job () {
      return this.sitimmoUser.metier
    },
    sitimmoLogin () {
      return this.sitimmoUser.login
    },
    username () {
      return this.user.username
    },
    typeOffre () {
      return this.post.typeOffre
    },
    typeObjet () {
      return getFromSnake(this.post, 'type_objet')
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isBailleurSocial () {
      return this.sitimmoUser.metier === 'BAILLEUR_SOCIAL'
    },
    isCmiste () {
      return this.sitimmoUser.metier === 'CMI'
    },
    isUSH () {
      return this.user.isUSH
    },
    pageTitle () {
      // Utiliser l'URL comme source de vérité
      const creationProgramme = getCreationProgrammeFromRoute(this.$route, this.post, this.sitimmoUser.metier)

      if (this.isPromoteur || (this.isBailleurSocial && creationProgramme)) {
        if (this.$route.query.annonceParente) {
          return this.$t('posts.edit.pageTitleLot')
        } else {
          return this.$t('posts.edit.pageTitleProgram')
        }
      }
      if (this.$route.name == 'model-edit') {
        return this.$t('posts.edit.pageTitleModele')
      }
      return this.$t('posts.edit.pageTitleAd')
    }
  },
  async beforeMount () {
    this.$route.meta.title = this.pageTitle
    if (!this.post.nbDiffusions) {
      this.post.nbDiffusions = 0
    }
    if (this.$route.params.type) {
      this.currentType = this.$route.params.type
      if (this.currentType === 'modele') {
        this.post.typeObjet = 1200
      }
      if (this.currentType === 'terrain') {
        this.post.typeObjet = 1310
      }
    }
    if (this.$route.params && this.$route.params.id) {
      this.create = false


      this.post = await getPostById(this.$route.params.id)

      // Synchroniser l'annonce parente dans le store AVANT postLoaded = true,
      // pour que PostFormObjectType ait le bon filter.annonceParente dès son montage
      // et appelle getObjectTypes() avec le bon contexte programme (sinon le champ
      // "Type de bien" reste vide car les types retournés n'incluent pas le sous-type du lot).
      if (this.isPromoteur || this.isBailleurSocial) {
        const annonceParenteFromUrl = getAnnonceParenteFromRoute(this.$route)
        this.$store.commit('postsListImmo/SET_ANNONCE_PARENTE', annonceParenteFromUrl || null)
        this.$route.meta.title = this.pageTitle
      }

      // Marquer que le post est chargé AVANT de continuer
      this.postLoaded = true

      // Attendre un tick pour que Vue traite le changement
      await this.$nextTick()

      // Appeler assignUser() après le chargement du post
      // Pour les subUsers : toujours appeler pour charger leurs coordonnées
      // Pour les autres utilisateurs : toujours appeler pour définir un contact par défaut si nécessaire
      await this.assignUser()

      if (this.post.emission && this.post.emission.picturesManagedBySeize) {
        this.SET_MEDIA_UPLOAD_DISABLED(false)
      }
      if (this.post.typeObjet >= 1300 && this.post.typeObjet < 1400) {
        delete (this.rules.surface_habitable)
      }
      if (typeof this.post.prix === 'string') {
        this.post.prix = parseInt(this.post.prix)
      }

      if (this.post.type === 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }
      if (this.post.taux_tva === 5.5) {
        this.post.TVA_55 = 'oui'
      } else if (this.post.taux_tva === 7) {
        this.post.TVA_7 = 'oui'
      }
      if (this.isCmiste === true && this.post.etat === 'M') {
        if (this.post.typeObjet >= 1200 && this.post.typeObjet < 1300) {
          this.currentType = 'modele'
        } else if (this.post.typeObjet >= 1310 && this.post.typeObjet < 1400) {
          this.currentType = 'terrain'
        }
      }
      this.formatPostBooleanValues(this.post)
    } else {
      this.create = true
      // Pour les nouvelles créations, marquer comme chargé immédiatement
      this.postLoaded = true
    }

    if (this.post.typeObjet >= 3000 && this.post.typeObjet < 4000 && this.isBailleurSocial && !this.$route.query.annonceParente) {
      this.$route.meta.title = this.$t('posts.edit.pageTitleProgram')
      if (this.rules.prix && this.rules.prix[0]) {
        this.rules.prix[0].required = false
      }
      if (this.rules.prix_min && this.rules.prix_min[0]) {
        this.rules.prix_min[0].required = false
      }
      if (this.rules.prix_max && this.rules.prix_max[0]) {
        this.rules.prix_max[0].required = false
      }
      if (this.rules.code_postal && this.rules.code_postal[0]) {
        this.rules.code_postal[0].required = false
      }
      if (this.rules.code_postal_reel && this.rules.code_postal_reel[0]) {
        this.rules.code_postal_reel[0].required = false
      }
      if (this.rules.ville_reelle && this.rules.ville_reelle[0]) {
        this.rules.ville_reelle[0].required = false
      }
      if (this.rules.ville_contact_a_afficher && this.rules.ville_contact_a_afficher[0]) {
        this.rules.ville_contact_a_afficher[0].required = false
      }
      // Plus besoin de définir creationProgramme - déterminé par l'URL
    }
    if (this.post.annonceParente && this.isBailleurSocial) {
      if (this.rules.prix && this.rules.prix[0]) {
        this.rules.prix[0].required = false
      }
      if (this.rules.prix_min && this.rules.prix_min[0]) {
        this.rules.prix_min[0].required = false
      }
      if (this.rules.prix_max && this.rules.prix_max[0]) {
        this.rules.prix_max[0].required = false
      }
      if (this.rules.code_postal && this.rules.code_postal[0]) {
        this.rules.code_postal[0].required = false
      }
      if (this.rules.code_postal_reel && this.rules.code_postal_reel[0]) {
        this.rules.code_postal_reel[0].required = false
      }
      if (this.rules.ville_reelle && this.rules.ville_reelle[0]) {
        this.rules.ville_reelle[0].required = false
      }
      if (this.rules.ville_contact_a_afficher && this.rules.ville_contact_a_afficher[0]) {
        this.rules.ville_contact_a_afficher[0].required = false
      }
    }
    // Déterminer le contexte programme basé sur l'URL
    const creationProgramme = getCreationProgrammeFromRoute(this.$route, this.post, this.sitimmoUser.metier)

    if (this.isPromoteur || (this.isBailleurSocial && creationProgramme)) {
      if (this.$route.query.annonceParente) {
        if (this.rules.code_postal && this.rules.code_postal[0]) {
          this.rules.code_postal[0].required = false
        }
        if (this.rules.code_postal_reel && this.rules.code_postal_reel[0]) {
          this.rules.code_postal_reel[0].required = false
        }
        if (this.rules.ville_reelle && this.rules.ville_reelle[0]) {
          this.rules.ville_reelle[0].required = false
        }
        if (this.rules.ville_contact_a_afficher && this.rules.ville_contact_a_afficher[0]) {
          this.rules.ville_contact_a_afficher[0].required = false
        }
      } else {
        if (this.rules.prix && this.rules.prix[0]) {
          this.rules.prix[0].required = false
        }
        if (this.rules.prix_min && this.rules.prix_min[0]) {
          this.rules.prix_min[0].required = false
        }
      }
    }

    if (this.isUSH) {
      const isTerrain = this.post.typeObjet >= 1300 && this.post.typeObjet < 1400
      if (!isTerrain && this.rules.nb_pieces_logement && this.rules.nb_pieces_logement[0]) {
        this.rules.nb_pieces_logement[0].required = true
      }
    }
    if (this.universe === 'VO') {
      if (this.rules.code_postal && this.rules.code_postal[0]) {
        this.rules.code_postal[0].required = false
      }
      if (this.rules.ville && this.rules.ville[0]) {
        this.rules.ville[0].required = false
      }
      delete (this.post.communiquer_adresse_exacte)
    }
    if (!this.create) {
      this.$store.commit('donnees/SET_DEVISE', this.post.devise_iso_4217)
    } else {
      this.$store.commit('donnees/SET_DEVISE', 'EUR')
    }

  },
  created () {
    // si on fait un changement de langue sur une page d'édition, les labels peuvent ne pas avoir le temps de
    // se charger. Le code suivant attend un peu avant d'afficher les components si besoin.
    if (this.$labels === undefined) {
      setTimeout(() => {
        this.labelsLoaded = true
      }, 4000)
    } else {
      this.labelsLoaded = true
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.redirectToList && this.redirect == false) {
      const answer = window.confirm(this.$t('posts.edit.alertBeforeLeave'))
      if (answer) {
        // Plus besoin de nettoyer creationProgramme - déterminé par l'URL
        next()
      }
      // } else {
      //     next(false)
      // }
    } else {
      next()
    }
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.PostEdit {
  &-content {
    padding-top: map-get($spacers, 3);
  }

  &-tabs {
    /* CORRECTION SAFARI : on utilise ::v-deep pour cibler l'intérieur du composant Element UI */
    ::v-deep .el-tabs__content {
      display: none !important;
    }

    .el-tabs__header {
      margin: 0;
    }

    .el-tabs__nav-wrap::after {
      display: none;
    }

    .el-tabs__item {
      outline: none !important;

      &:focus {
        outline: none !important;
      }
    }
  }
}

.el-message-box.reference-length-confirm {
  width: 720px;
  max-width: calc(100vw - 32px);

  .el-message-box__message {
    padding-left: 0;

    p {
      margin: 0;
    }
  }
}

.reference-length-confirm__text,
.reference-length-confirm__question,
.reference-length-confirm__note {
  display: block;
  margin: 0;
  line-height: 1.5;
}

.reference-length-confirm__text {
  margin-bottom: 12px;
}

.reference-length-confirm__question {
  margin-bottom: 16px;
  font-weight: 600;
}

.reference-length-confirm__note {
  padding: 10px 12px;
  font-size: 13px;
  color: #606266;
  background: #f4f4f5;
  border-radius: 4px;
}
</style>
